import { ReactNode } from 'react';
import { StatusBadgeBaseRoot, StatusBadgeLabel } from './styles';
import type { StatusBadgePrefix, StatusBadgeTone } from './statusMapping';

type StatusBadgeBaseProps = {
  tone: StatusBadgeTone;
  prefix?: StatusBadgePrefix;
  /** 완료는 wrapper 가 날짜 라벨 생성. */
  label: string;
  /** prefix 대신 직접 노출할 커스텀 아이콘. */
  customPrefix?: ReactNode;
  /** 'tag' = 연관품의 태그. */
  variant?: 'default' | 'tag';
  /** 기본 톤색 대신 주입할 색. */
  palette?: { color: string; bg: string; border: string };
};

const renderPrefixIcon = (prefix: StatusBadgePrefix): ReactNode => {
  switch (prefix) {
    case 'asterisk':
      return (
        <svg viewBox="0 0 12 12" fill="none" aria-hidden>
          <path
            d="M6 1.5v9M1.5 6h9M2.6 2.6l6.8 6.8M9.4 2.6L2.6 9.4"
            stroke="currentColor"
            strokeWidth="1.2"
            strokeLinecap="round"
          />
        </svg>
      );
    case 'check':
      return (
        <svg viewBox="0 0 12 12" fill="none" aria-hidden>
          <path
            d="M2.5 6.2 5 8.5l4.5-4.8"
            stroke="currentColor"
            strokeWidth="1.4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'warning':
      return (
        <svg viewBox="0 0 12 12" fill="none" aria-hidden>
          <path
            d="M6 1.5 11 10H1L6 1.5Z"
            stroke="currentColor"
            strokeWidth="1.2"
            strokeLinejoin="round"
          />
          <path
            d="M6 5v2.5"
            stroke="currentColor"
            strokeWidth="1.2"
            strokeLinecap="round"
          />
          <circle cx="6" cy="9" r="0.6" fill="currentColor" />
        </svg>
      );
    case null:
    default:
      return null;
  }
};

const StatusBadgeBase = ({
  tone,
  prefix = null,
  label,
  customPrefix,
  variant,
  palette,
}: StatusBadgeBaseProps) => {
  return (
    <StatusBadgeBaseRoot
      tone={tone}
      variant={variant}
      paletteOverride={palette}
      // 스타일 무변경 hook — tag 딱지를 컨테이너 스코프 CSS(예: 변경이력 모달 모바일)에서만 선택하기 위함.
      className={variant === 'tag' ? 'approval-status-tag' : undefined}
    >
      {customPrefix ?? renderPrefixIcon(prefix)}
      <StatusBadgeLabel>{label}</StatusBadgeLabel>
    </StatusBadgeBaseRoot>
  );
};

export default StatusBadgeBase;
